import { assign } from "lodash-es";

function selectFiles({ multiple = false, accept, folder = false }, callback) {
  if (window.selectFilesMock) {
    callback(window.selectFilesMock);
    window.selectFilesMock = null;
    return;
  }

  const input = document.createElement("input");
  input.setAttribute("type", "file");
  if (accept) input.setAttribute("accept", accept);
  if (multiple) input.setAttribute("multiple", "true");
  if (folder) {
    input.setAttribute("webkitdirectory", true);
    input.setAttribute("allowdirs", true);
  }

  assign(input.style, {
    position: "fixed",
    bottom: "10px",
    right: "10px",
    opacity: "0.1;",
    visibility: "hidden",
  });

  document.body.appendChild(input);

  input.addEventListener("change", () => callback([...input.files]));
  input.click();
}

export default selectFiles;
